"use client";

import React from "react";

type Props = {
  className?: string;
  width?: number;
  height?: number;
  title?: string;
  fill?: string;
};

const QuoteDouble: React.FC<Props> = ({
  className,
  width = 29,
  height = 25,
  title = "Quote Icon",
  fill = "#D4AF37",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29 25"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      <path
        d="M12.3177 0.500896C12.3177 1.0559 12.3617 1.5209 12.2977 1.9699C12.2707 2.1609 12.0477 2.3659 11.8647 2.4809C10.9777 3.0439 10.0147 3.4939 9.18771 4.1399C6.51171 6.2319 4.92571 8.9859 4.83871 12.5639C4.81471 13.5789 5.18871 13.8339 6.04071 13.4369C8.50371 12.2949 11.1527 12.9649 12.5657 15.0869C14.1067 17.4029 13.8897 20.4869 12.0427 22.5089C9.68471 25.0909 5.80271 25.1689 3.12571 22.7009C1.52271 21.2229 0.760711 19.3149 0.570711 17.1439C-0.0662889 9.8729 3.58071 3.8789 10.2197 1.2459C10.8767 0.985897 11.5497 0.771896 12.3177 0.500896Z"
        fill={fill}
      />
      <path
        d="M27.3177 0.500896C27.3177 1.0559 27.3617 1.5209 27.2977 1.9699C27.2707 2.1609 27.0477 2.3659 26.8647 2.4809C25.9777 3.0439 25.0147 3.4939 24.1877 4.1399C21.5117 6.2319 19.9257 8.9859 19.8387 12.5639C19.8147 13.5789 20.1887 13.8339 21.0407 13.4369C23.5037 12.2949 26.1527 12.9649 27.5657 15.0869C29.1067 17.4029 28.8897 20.4869 27.0427 22.5089C24.6847 25.0909 20.8027 25.1689 18.1257 22.7009C16.5227 21.2229 15.7607 19.3149 15.5707 17.1439C14.9337 9.8729 18.5807 3.8789 25.2197 1.2459C25.8767 0.985897 26.5497 0.771896 27.3177 0.500896Z"
        fill={fill}
      />
    </svg>
  );
};

export default QuoteDouble;
